import { Box, Chip } from "@mui/material";

export default function GroupDisplay({ filterAutofIllData, tag, onClick }) {
  if (!tag) return null;
  return (
    <Box sx={{ display: "flex", gap: "4px" }}>
      {tag.split(",").map((tag) => {
        const tagObject = (filterAutofIllData?.Tag || []).find(
          (item) => item.label === tag
        );

        return (
          <Chip
            key={tag}
            sx={{ fontSize: "1.25rem", cursor: "pointer" }}
            label={tag}
            variant="outlined"
            onClick={() => onClick(tagObject)}
          />
        );
      })}
    </Box>
  );
}
